
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FcnavbarComponent } from './fcnavbar.component';
import { FcnavmenuComponent } from './fcnavmenu.component';
import { FcnavsideComponent } from './fcnavside.component';
import { FcnavtabComponent } from './fcnavtab.component';
import { FcbasicModule } from '../fcbasic/index.module';
import { FcmodalModule } from '../fcmodal/index.module';
import { FclistModule } from '../fclist/index.module';
import { FcshareModule } from '../fcshare.modal';
import { FcnavtabcontentDirective } from './fcnavtabcontent.directive';
import { FcnavtabtplComponent } from './fcnavtabtlp';
@NgModule({
  imports: [
    FcshareModule,
    FcbasicModule,
    FcmodalModule,
    FclistModule
  ],
  exports: [
    FcnavbarComponent,
    FcnavmenuComponent,
    FcnavsideComponent,
    FcnavtabComponent,
    FcnavtabcontentDirective,
    FcnavtabtplComponent
  ],
  declarations: [
    FcnavbarComponent,
    FcnavmenuComponent,
    FcnavsideComponent,
    FcnavtabComponent,
    FcnavtabcontentDirective,
    FcnavtabtplComponent
  ],
  providers: [
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class FcnavModule { }
